import { Outlet } from 'react-router-dom';

import { CrmLinkWarning } from './CrmLinkWarning';
import { MobileNav } from './MobileNav';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import styles from './AppLayout.module.css';

export function AppLayout() {
  return (
    <>
      <Topbar />
      <CrmLinkWarning />
      <div className={styles.shell}>
        <Sidebar />
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>
      <MobileNav />
    </>
  );
}
